var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"vts-resize"},[_vm._t("default",null,null,{ width: _vm.width, height: _vm.height, inlineSize: _vm.width, blockSize: _vm.height })],2)}
var staticRenderFns = []

export { render, staticRenderFns }